import { useTranslation } from "react-i18next";
import {
  InfoField,
  MetadataSection,
} from "~/molecules/DocumentMetadataSections";
import { type WorkflowDetails } from "~/api/types";
import { DueDateCell } from "~/molecules/DueDateCell";

interface Props {
  workflow: WorkflowDetails;
}

export default function WorkflowDates({ workflow }: Props) {
  const { t } = useTranslation();

  const workflowStartedAt = workflow.stepInstances[0]?.createdAt;
  const workflowEndedAt = workflow.documentVersion.publishedAt;

  return (
    <MetadataSection title={t(($) => $.commons.document.reviewDates)}>
      <div className="grid grid-cols-2">
        <InfoField label={t(($) => $.commons.document.reviewFrom)}>
          <DueDateCell
            dueDate={workflow.documentVersion.reviewFrom}
            className={workflowStartedAt ? "text-muted-foreground" : undefined}
            showTriangleAlert={workflowStartedAt === undefined}
          />
        </InfoField>
        <InfoField label={t(($) => $.commons.document.reviewTo)}>
          <DueDateCell
            dueDate={workflow.documentVersion.reviewTo}
            className={workflowEndedAt ? "text-muted-foreground" : undefined}
            showTriangleAlert={workflowEndedAt === null}
          />
        </InfoField>
      </div>
    </MetadataSection>
  );
}
